import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class SellerService {
    constructor(private datatask: DataTaskService) {}

    public async getSeller(seller_id: string): Promise<SellerGet> {
        return (await this.datatask.Post(1387, { seller_id }))[0];
    }

    public async getSettings(): Promise<SellersGet> {
        return (await this.datatask.Post(1385, {}))[0];
    }

    public listSellers(params: SellersGet): Promise<SellerItem[]> {
        return this.datatask.Post(1386, params);
    }

    public lookup(searchtext: string): Promise<SellerLookupItem[]> {
        return this.datatask.Post(2783, { searchtext });
    }

    public async save(page: SellerGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(1388, page))[0];
    }
}

export interface SellerGet extends Record<string, unknown> {
    seller_id: string;
    labour_no: string;
    seller_name: string;
    businessco_no: string;
    isactive: string;
}
export interface SellersGet extends Record<string, unknown> {
    gb_sellers_main: string;
    businessco_no: string;
    filtervalue: string;
}
export interface SellerLookupItem {
    labour_no: string;
    labour_name: string;
    labour_keyname?: string;
}
export interface SellerItem extends Item {
    item_id: string;
    item_name: string;
    item_state: string;
    item_action?: (item: SellerItem) => void;
}
